<template>
  <div class="head-title">
    <div class="left">
      <ul class="breadcrumb">
        <li>
          <router-link to="/purchases/home" class="active">{{
            $t("purchases")
          }}</router-link>
        </li>
        <li>-</li>
        <li>
          <a class="active"
            >{{ $t("balance") }} {{ $t("suppliers") }}</a
          >
        </li>
      </ul>
    </div>
  </div>
  <div class="main">
    <div class="head">
      <div class="head1">
        <!-- <span>{{ $t("supplier") }}</span> &nbsp;&nbsp;
        <v-select
          :options="accounts"
          label="name"
          v-model="item"
          style="background-color: white; color: black; width: 30%"
        >
          <template #option="option">
            <span style="color: black"> {{ option.name }}</span>
          </template> </v-select
        >&nbsp;&nbsp; -->
        {{ $t("date") }}
        <input
          type="date"
          :placeholder="$t('from')"
          v-model="from"
          @change="submit"
        />
        <!-- {{ $t("to") }}
        <input
          type="date"
          :placeholder="$t('to')"
          v-model="to"
          @change="submit"
        /> -->
      </div>
    </div>
    <!-- <div class="body" v-if="this.view == 0">برجاء اختيار اسم العميل</div> -->
    <div class="body" id="main">
      <div style="padding: 2%; direction: rtl; font-size: small">
        <h3>
          {{ $t("balance") }} {{ $t("suppliers") }}
        </h3>
        <h6>{{ $t("date") }} : {{ fromdate }}</h6>
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t("name") }}</th>

              <th>{{ $t("balance") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in alldata" :key="i">
              <td>{{ i.name }}</td>
              <td>{{ Number(i.balance).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="buttom">
      <button
        class="buttonconfirm"
        type="submit"
        v-if="this.view != 0"
        @click="pdf"
      >
        <i class="bi bi-filetype-pdf"></i> {{ $t("PDF") }}
      </button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// import moment from "moment";
// import vSelect from "vue-select";
import html2pdf from "html2pdf.js";
export default {
  components: {
    // vSelect,
  },
  // async mounted() {
  //   const result2 = await axios.get("/data/allsupplier");
  //   if (result2.status == 200) {
  //     this.accounts = result2.data.data;
  //   }
  // },
  props: ["css"],
  data() {
    return {
      item: "",
      fromdate: "",
      todate: "",
      alldata: [],
      view: "",
      namear: "",
      nameen: "",
      typeact: "",
      accounts: [],
      openbalance: "",
      totalbalance: 0,
      totaldpt: 0,
      totalcrd: 0,
      from: "",
      to: "",
    };
  },
  methods: {
    async submit() {
      const result = await axios.get(
        `/reports/supplierbalance/${this.from}`
      );
      if (result.status == 200) {
            this.fromdate = this.from;
        this.alldata = result.data.data
      }
    },
    pdf() {
      html2pdf(document.getElementById("main").innerHTML, {
        margin: 0.1,
        filename: `Statement-${this.item.name}.pdf`,
        image: { type: "jpeg", quality: 100 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
    print2() {
      this.$htmlToPaper("main");
    },
  },
  watch: {
    filter() {
      this.accounts = this.accounts.filter((x) =>
        x.namear.includes(this.filter.toLowerCase())
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  // direction: v-bind("css.EN");
  padding: 0.5%;
}

.main {
  width: 98%;
  margin: 1%;
  padding: 1%;
  // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 5px;
  border: ridge 0.5px;
}

.head {
  padding: 0.25%;
  display: flex;
  border-bottom-style: ridge;
}

.head1 {
  width: 70%;
  display: flex;
}

.head1 input {
  margin: 0.5%;
  padding: 0.5%;
  border: none;
  border-radius: 5px;
  background-color: #eee;
}

.head2 {
  width: 30%;
  text-align: center;
}

.head2 button {
  margin: 0.5%;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: rgba(98, 153, 174, 255);
  color: white;
}

.head2 button a {
  color: white;
}

.table {
  margin-top: 1%;
}

table thead tr {
  border-radius: 5px;
  background-color: #eee;
}

select {
  width: 15%;
  margin: 0.5%;
  // padding: 0.5%;
  border: none;
  border-radius: 5px;
  background-color: #eee;
}

@media screen and (max-width: 576px) {
  .table {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    background-color: white;
    font-size: xx-small;
  }
}
</style>
